import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './Modal.css';

const AccountsModal = ({ isOpen, onClose, deal }) => {
  if (!deal) return null;

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="modal-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          <motion.div
            className="modal-container"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-header">
              <h2>{deal.companyName}</h2>
              <button className="modal-close" onClick={onClose}>×</button>
            </div>

            <div className="modal-body">
              <div className="modal-section">
                <h3>MOU Details (Detail Sheet)</h3>
                <div className="detail-grid">
                  <div className="detail-item">
                    <span className="detail-label">MOU Number:</span>
                    <span className="detail-value">{deal.mouNumber}</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Student Name:</span>
                    <span className="detail-value">{deal.studentName}</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Year:</span>
                    <span className="detail-value">{deal.year}</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Company:</span>
                    <span className="detail-value">{deal.companyName}</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">MOU Amount:</span>
                    <span className="detail-value amount">₹{deal.amount}</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Student Email:</span>
                    <span className="detail-value">{deal.email}</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Student Phone:</span>
                    <span className="detail-value">{deal.phone}</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">POC Name:</span>
                    <span className="detail-value">{deal.pocName}</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">POC Email:</span>
                    <span className="detail-value">{deal.pocEmail}</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">POC Phone:</span>
                    <span className="detail-value">{deal.pocPhone}</span>
                  </div>
                </div>
              </div>

              {(deal.paymentAmount || deal.paymentTransactionId) && (
                <div className="modal-section">
                  <h3>Payment Details (Payment Sheet)</h3>
                  <div className="detail-grid">
                    {deal.paymentAmount && (
                      <div className="detail-item">
                        <span className="detail-label">Payment Amount:</span>
                        <span className="detail-value amount">₹{deal.paymentAmount}</span>
                      </div>
                    )}
                    {deal.paymentTransactionId && (
                      <div className="detail-item">
                        <span className="detail-label">Transaction ID:</span>
                        <span className="detail-value">{deal.paymentTransactionId}</span>
                      </div>
                    )}
                    {deal.paymentSubmittedAt && (
                      <div className="detail-item">
                        <span className="detail-label">Payment Submitted:</span>
                        <span className="detail-value">{deal.paymentSubmittedAt}</span>
                      </div>
                    )}
                  </div>
                </div>
              )}

              <div className="modal-section">
                <h3>Verification Status</h3>
                <div className="detail-grid">
                  <div className="detail-item">
                    <span className="detail-label">MOU Status:</span>
                    <span className={`status-badge ${deal.mouVerified ? 'verified' : 'pending'}`}>
                      {deal.mouVerified ? '✓ Verified' : '⏳ Pending'}
                    </span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Payment Status:</span>
                    <span className={`status-badge ${deal.paymentVerified ? 'verified' : 'pending'}`}>
                      {deal.paymentVerified ? '✓ Verified' : '⏳ Pending'}
                    </span>
                  </div>
                </div>
              </div>

              <div className="modal-section">
                <h3>Documents</h3>
                <div className="mou-preview">
                  {deal.mouUrl && (
                    <a
                      href={deal.mouUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-primary"
                    >
                      View MOU Document
                    </a>
                  )}
                  {deal.paymentProofUrl && (
                    <a
                      href={deal.paymentProofUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-primary"
                      style={{ marginLeft: '12px' }}
                    >
                      View Payment Proof
                    </a>
                  )}
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default AccountsModal;
